module.exports = __webpack_public_path__ + "img/pinkSapphire@2x.217ee8b.webp";